import { createAction, Dispatch } from '@reduxjs/toolkit';

export const toggleDarkMode = createAction<boolean>('toggleDarkMode');

export const toggleTheme = (isDarkModeEnabled: boolean) => (
    dispatch: Dispatch,
) => {
    return dispatch(toggleDarkMode(isDarkModeEnabled));
};
